/* @flow */
import * as React from "react";
import styled from "styled-components";

import Gettext from "./Gettext";
import { Link } from "./Link";
import { isIronTerminal, iOSAppPostMessage } from "../utils";

import { fontSize, rtl } from "./styled-mixins";

const Support = styled(Link)`
  direction: ${props => props.theme.direction};
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-content: center;
  align-items: center;
  flex: 0 0 auto;
  margin-left: auto;
  font-size: ${fontSize(14)};
  line-height: 17px;
  white-space: nowrap;
  text-decoration: none;
  color: ${({ theme }) => theme.mainLink};

  :hover,
  :focus,
  :active {
    text-decoration: underline;
    color: ${({ theme }) => theme.accent};
  }
`;

const Svg = styled.svg`
  width: 17px;
  height: 17px;
  ${rtl("margin-left", "10px")};
  fill: #a5a4a4;
`;

export const Icon = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="1132.1 517.1 19.9 19.9">
    <path d="M1142.05 517.1a9.95 9.95 0 1 0 9.95 9.95 9.949 9.949 0 0 0-9.95-9.95zm0 4.64a1.249 1.249 0 1 1-1.25 1.25 1.249 1.249 0 0 1 1.25-1.25zm2.186 10.62h-4.372v-1.874h.936v-3.748h-.936v-1.874h3.436v5.622h.937v1.874z" />
    <path d="M1134.472 532.301l-1.17 4.366 4.366-1.17z" />
  </Svg>
);

type Props = {
  to?: string,
  children?: React.Node
};

export default function SupportLink({
  to = "/helpdesk",
  children,
  ...props
}: Props) {

  let onClick = props.onClick || null;

  if (isIronTerminal()) {
    onClick = e => {
      if (e) e.preventDefault();

      if (props.onClick && typeof props.onClick === "function") {
        props.onClick(e);
      }

      iOSAppPostMessage("gotoSupport");
    };
  }

  return (
    <Support {...props} to={to} onClick={onClick}>
      {children || <Gettext>Need any help?</Gettext>}
      <Icon />
    </Support>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/SupportLink.js